export default __webpack_public_path__ + "static/pie-with-variable-radius-f443b36bd2b8ff3e25384e1a2cfeba5c.png";